// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","477":"LogoMakerGuestLazyComponent"}[chunkId] + "." + {"46":"fcfdc0296e5bf86caef0","477":"72b15f21d80265d9c9ea"}[chunkId] + ".js";
};